<template>
    <PlanbordGridCell info clickable centeredVertically @click="openModal">
        <span class="nameMarker">{{ companyEmployee.name }}</span>
        <span class="external-roster-label">({{ company.name }})</span>
    </PlanbordGridCell>
</template>

<script lang="ts">
    import {Component, Vue, Prop} from 'vue-facing-decorator';
    import {Company, CompanyEmployee} from '@cquential/api';
    import CompanyEmployeeDetailsModal from '@/components/modals/CompanyEmployeeDetailsModal.vue';
    import PlanbordGridCell from '@/components/Planbord/PlanbordGridCell.vue';

    @Component({
        components: {
            PlanbordGridCell,
        },
    })
    export default class CompanyEmployeeNameCell extends Vue {
        @Prop({required: true}) public company!: Company;
        @Prop({required: true}) public companyEmployee!: CompanyEmployee;

        public openModal(): void {
            if (!this.companyEmployee) {
                console.error('Cannot open resource information modal if there is no resource.');

                return;
            }

            /** @see CompanyEmployeeDetailsModal.open() */
            // @ts-expect-error TS2339
            CompanyEmployeeDetailsModal.__vfdConstructor.open(this.companyEmployee, this.company);
        }
    }
</script>

<style lang="scss" scoped>
    .external-roster-label {
        font-weight: 700;
        padding: 0.2rem;
        display: block;
    }
</style>
